"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = require("../shared/resource");
var CustomFieldKind;
(function (CustomFieldKind) {
    CustomFieldKind["Truck"] = "truck";
    CustomFieldKind["Job"] = "job";
    CustomFieldKind["Driver"] = "driver";
    CustomFieldKind["Share"] = "jobeventshare";
})(CustomFieldKind = exports.CustomFieldKind || (exports.CustomFieldKind = {}));
var CustomField = /** @class */ (function (_super) {
    __extends(CustomField, _super);
    function CustomField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.active = true;
        return _this;
    }
    return CustomField;
}(resource_1.Resource));
exports.CustomField = CustomField;
